var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCopyIconGray = function SvgCopyIconGray(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427321033"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0526 0.662476H1.57895C0.710526 0.662476 0 1.27611 0 2.02611V11.5716H1.57895V2.02611H11.0526V0.662476ZM13.4211 3.38975H4.73684C3.86842 3.38975 3.15789 4.00338 3.15789 4.75338V14.2988C3.15789 15.0488 3.86842 15.6625 4.73684 15.6625H13.4211C14.2895 15.6625 15 15.0488 15 14.2988V4.75338C15 4.00338 14.2895 3.38975 13.4211 3.38975ZM13.4211 14.2988H4.73684V4.75338H13.4211V14.2988Z",
    fill: "#002E5C"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopyIconGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CopyIconGray.32f521c1.svg";
export { ForwardRef as ReactComponent };